import ApiHelper from "../../helpers/ApiHelper";
import BaseService from "../BaseService";

class PageMetaService extends BaseService {
    static url = "metas";
    static apis = {
        that: this,
        getfilteredPageMetas: function (id) {
            return this.that.url + "/page-metas/" + id;
        },

        getfilteredPageMetaTrans: function (id) {
            return this.that.url + "/page-meta-trans/" + id;
        },
    };

    constructor(repo) {
        super(repo);
        this.repo = new ApiHelper("metas");
    }

    getPageMetas(id) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: PageMetaService.apis.getfilteredPageMetas(id),
                    method: "GET",
                    authorization: false,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                });
        });

    }

    getPageMetaTrans(id) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: PageMetaService.apis.getfilteredPageMetaTrans(id),
                    method: "GET",
                    authorization: false,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }


}

export default PageMetaService;